import { PhaseFormOutputDTO, PhaseFormFieldData } from './types';

export const phaseFormMapper = {
  toDTO: (data: Partial<PhaseFormOutputDTO>): Partial<PhaseFormOutputDTO> => {
    return {
      ...data,
      hasAppointment: data.hasAppointment || false,
      appointmentId: data.hasAppointment ? data.appointmentId : undefined,
      formFields: data.formFields?.map((field: PhaseFormFieldData) => ({
        ...field,
        // Extrai apenas o ID se for um objeto
        assetType:
          field.assetType && typeof field.assetType === "object"
            ? (field.assetType as any)._id
            : field.assetType,
        processRole:
          field.processRole && typeof field.processRole === "object"
            ? (field.processRole as any)._id
            : field.processRole,
        acceptFiles: field.acceptFiles,
      })),
    };
  },

  toView: (data: PhaseFormOutputDTO): PhaseFormOutputDTO => {
    return {
      ...data,
      hasAppointment: data.hasAppointment || false,
    };
  },
};
